import { Component, Input } from "@angular/core";
import { Course } from "@core/domain/course";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "pa-replacement-info",
  templateUrl: "./replacement-info.component.html",
  styleUrls: ["./replacement-info.component.scss"],
  imports: [TranslateModule],
})
export class ReplacementInfoComponent {
  @Input() course!: Course;
}
